module.exports = __webpack_public_path__ + "static/media/mapa.f96d3096.jpeg";